<template>
  <div :class="[classes.cardHeader, layoutClass]">
    <CardName :class="[classes.cardName]">
      Parlay
    </CardName>
    <FixtureSport
      :id="marketBranding?.marketNameFont"
      :class="[classes.fixtureSport, 'sport']"
    >
      {{ eventSport }}
    </FixtureSport>
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, defineComponent } from "vue";

import {
  injectBrand,
  BrandContext
} from "@fresh8/ad-data-composition/src/brand";
import { composeEvent } from "@fresh8/ad-data-composition/src/betData";

import FixtureSport from "../../../branded/FixtureSport.vue";
import { injectLayout, SMALL_RESPONSIVE } from "../../../../hooks/useLayout";
import { getSport } from "../../../../lib/language";
import CardName from "../../../branded/CardName.vue";
import { Sport } from "@fresh8/types/src/language";

const useStyles = createUseStyles({
  cardHeader: {
    width: "100%",
    borderBottom: props => `1px solid ${props.marketBorderColor || "#dcddf"}`,
    display: "flex",
    justifyContent: "space-between",
    fontSize: "10px",
    padding: "0 8px",
    height: "20px",
    boxSizing: "border-box",
    alignItems: "center",
    flex: "none",

    [`&.${SMALL_RESPONSIVE}`]: {
      height: "17px",
      flex: "1 0 17px",
      padding: "0 6px",
      maxHeight: "17px"
    }
  },
  cardName: {
    flex: 1
  },
  fixtureSport: {
    flex: 1,
    textAlign: "right"
  }
});

export default defineComponent({
  name: "MPUParlayCardHeader",
  components: {
    FixtureSport,
    CardName
  },
  props: {
    eventId: { type: String, required: true },
    displaySport: { type: Boolean, default: true }
  },
  setup(props) {
    const { layout } = injectLayout();
    const {
      adTemplateBranding,
      marketBranding
    } = injectBrand() as BrandContext;
    const event = composeEvent(props.eventId);
    const eventSport = computed(() =>
      props.displaySport ? getSport(event?.value?.sport as Sport) : ""
    );

    const classesRef = useStyles(
      computed(() => ({
        marketBorderColor: adTemplateBranding.value.marketBorderColor
      }))
    );

    return {
      classes: classesRef,
      eventSport,
      marketBranding,
      layoutClass: computed(() => layout.value)
    };
  }
});
</script>
